import { Info } from 'lucide-react';

/** Hinweis am Fuß des Kanäle-Reiters, wie ein weiteres Buchungsportal dazukommt. */
export function ChannelMappingBanner({ onOpenMapping }: { onOpenMapping: () => void }) {
  return (
    <div className="border-navy/20 bg-navy/5 mt-6 flex flex-wrap items-center justify-between gap-3 rounded-lg border px-4 py-3 text-sm">
      <div className="text-ink-soft flex min-w-0 items-start gap-2">
        <Info size={16} strokeWidth={2} className="text-navy mt-0.5 shrink-0" aria-hidden />
        <span>
          <span className="text-ink font-medium">Weiteres Portal verbinden?</span> Die Anmeldung
          läuft im Mapping-Fenster; eine Objektkennung wird dort nicht gebraucht.
        </span>
      </div>
      <button
        type="button"
        onClick={onOpenMapping}
        className="text-navy hover:text-sealwax inline-flex min-h-11 items-center gap-1 text-[13px] font-medium transition-colors"
      >
        Mapping öffnen
      </button>
    </div>
  );
}
